import TwoFactorSidebar from './TwoFactorSidebar';

const TwoFactorSidebars = [{ url: '2fa', Sidebar: TwoFactorSidebar }];

export default TwoFactorSidebars;
